import { render, staticRenderFns } from "./document-details.vue?vue&type=template&id=7ac76fe2&scoped=true&"
import script from "./document-details.vue?vue&type=script&lang=js&"
export * from "./document-details.vue?vue&type=script&lang=js&"
import style0 from "./document-details.vue?vue&type=style&index=0&id=7ac76fe2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac76fe2",
  null
  
)

component.options.__file = "document-details.vue"
export default component.exports